module.exports = __webpack_public_path__ + "static/media/flag-gr.f0c5b455.webp";